import { render, staticRenderFns } from "./BlackGoldSidebar.vue?vue&type=template&id=46b02be3"
import script from "./BlackGoldSidebar.vue?vue&type=script&lang=js"
export * from "./BlackGoldSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports